import { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import GreyBox from '@/components/common/GreyBox';
import {
  PaymentMethodInfo,
  UserPaymentInfo,
  WorkerPaymentInfoBox,
  MonthlyBillList,
  MonthlyBillDetailModal,
} from '@/components/newPayment';

import usePaymentInfo from '@/hooks/usePaymentInfo';
import useCompanyInfo from '@/hooks/useCompanyInfo';
import type { MonthlyBillDetail } from '@/types/company.types';
import { ROUTER } from '@/constants/constants';

const PaymentManagementPage = () => {
  const { data: paymentData } = usePaymentInfo();
  const { data: companyData } = useCompanyInfo();
  const [searchParams] = useSearchParams();
  const workerSectionRef = useRef<HTMLDivElement>(null);
  const [selectedBillId, setSelectedBillId] = useState<number | null>(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const section = searchParams.get('section');
    if (section === 'workers' && workerSectionRef.current) {
      setTimeout(() => {
        workerSectionRef.current?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }, 100);
    }
  }, [searchParams]);

  const handleBillClick = (billId: number) => {
    setSelectedBillId(billId);
    setIsDetailModalOpen(true);
  };

  const handlePayClick = (bill: MonthlyBillDetail) => {
    setIsDetailModalOpen(false);
    // Navigate to bill payment page
    navigate(`${ROUTER.PAYMENT_BILL}/${bill.id}`);
  };

  return (
    <GreyBox title='결제 관리' maxWidth='53.125rem' minWidth='34.375rem'>
      {paymentData && (
        <>
          <UserPaymentInfo 
            paymentData={paymentData.data} 
            companyData={companyData?.data}
          />
          <PaymentMethodInfo 
            paymentData={paymentData.data} 
            companyData={companyData?.data}
          />
          <div ref={workerSectionRef}>
            <WorkerPaymentInfoBox paymentData={paymentData.data} />
          </div>
          <MonthlyBillList onBillClick={handleBillClick} />
        </>
      )}
      {isDetailModalOpen && (
        <MonthlyBillDetailModal
          billId={selectedBillId}
          setIsModalOpen={setIsDetailModalOpen}
          onPayClick={handlePayClick}
        />
      )}
    </GreyBox>
  );
};

export default PaymentManagementPage;
